// New Branch Training Requests

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { uid } from 'chart.js/dist/helpers/helpers.core';
import { cloneDeep } from 'lodash';
import {
  Message,
  ConfirmationService,
  ConfirmEventType,
  MenuItem,
  MessageService,
} from 'primeng/api';
import { stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-new-branch-training-requests',
  templateUrl: './new-branch-training-requests.component.html',
  styleUrls: ['./new-branch-training-requests.component.scss'],
  providers: [MessageService],
})
export class NewBranchTrainingRequestsComponent {
  filterRequestData!: any;
  page: number = 1;
  rows: number = 10;
  first = 1;
  totalTraining: number = 0;
  allData: any;

  messages: Message[] = [];

  status: any;
  spinner = false;

  allowedRight = ['Ministries/Entities', 'Organisational Units', 'Branches'];
  translator: TranslatorPipe = new TranslatorPipe();

  //ou
  filteredData: any;
  selectionData: any;
  fieldModal = false;
  fieldData: string = '';
  treeData: any[] = [];
  parentOUS = ['الجهات المشاركة'];
  searchText: string = '';
  //filters
  typeFilter: any = undefined;
  oufilter: any = undefined;

  stats: stat[] = [
    { name: this.translate('active'), number: 84, icon: 'pi pi-check-circle' },
    { name: this.translate('Inactive'), number: 2, icon: 'pi pi-times-circle' },
  ];

  staticURL = GlobalConstants.staticFilesURL;
  selectedDate: Date = new Date();
  filteredStartDate!: Date;
  filteredEndDate!: Date;
  data: any;
  trainingRequestData!: any[];

  statusCounts: { [status: string]: number } = {};

  statusOptions: any[] = [
    // { name: this.translate('pending'), value: 'PENDING' },
    // { name: this.translate('Accepted'), value: 'APPROVED' },
    { name: this.translate('Draft'), value: 'TRAINING_CREATED' },
    // { name: this.translate('Rejected'), value: 'REJECTED' },
    { name: this.translate('Published'), value: 'PUBLISHED' },
    { name: this.translate('completed'), value: 'COMPLETED' },
    { name: this.translate('canceled'), value: 'CANCELED' },
  ];

  selected = 'New Branch';
  publishModal: boolean = false;

  rejectData = {
    _id: null,
    reason: null,
    status: '',
  };
  reasonError: any;
  rejectReason: any;
  requestHolder: any;

  createCourseModal: boolean = false;
  openCourseModal: boolean = false;
  fromCreateTraining: boolean = false;
  trainingDetails: any;
  permissions: any;
  managerOu: any;

  managerPage: boolean = false;

  ShowDashboard: boolean = false;
  showCalender: boolean = false;
  openAddKLModal = false;
  addTrainingProgram = false;
  selectKLCourse: any;
  DateRange: any;

  //Result related variables
  selectCourseForAssessmentResult: any;
  showSelectAssessmentModal: boolean = false;

  //pubish varables
  branchId: any;
  branchUser: any = undefined;
  unregisteredUsers: any = [];
  separatorExp: any = /,| /;

  constructor(
    private dataService: DataService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.managerOu = localStorage.getItem('managerOus');
    this.managerOu = this.managerOu ? JSON.parse(this.managerOu) : null;
    // if (this.managerOu && this.managerOu.length > 0) {
    //   this.managerPage = true;
    //   this.ShowDashboard = false;
    // } else {
    // }
    this.ShowDashboard = false;
    if(this.hasPermission('NEW_BRANCH_TRAINING_DASHBOARD', 'a')){
      this.ShowDashboard = true
    }

    this.getTrainingTypes().then(() => {
      this.getTreeData();
      this.getTrainingRequests();
    });
  }

  trainingTypes: any;

  onDateRangeChange() {
    if (this.DateRange && this.DateRange[0] && this.DateRange[1]) {
      this.getTrainingRequests();
    }
  }

  changeRoute(route: any, params: string[]) {
    this.router.navigate([route, ...params]);
  }

  // get training types
  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });
    if (res.error) {
      return;
    }
    this.trainingTypes = res.data.map((item: any) => {
      return {
        _id: item._id,
        name: item.name,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
        allowed_ou: item.allowed_ou,
      };
    });
  }

  getClasses(data: any) {
    if (!this.managerPage) {
      return data;
    } else '';
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async filter() {
    this.status = undefined;
    await this.getTrainingRequests();

    this.filterByMonth();
    this.status = undefined;
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  getAssessmentSessions(sessions: any[]): any[] {
    return sessions ? sessions?.filter((e) => e.type === 'ASSESSMENT') : [];
  }

  getSurveySessions(sessions: any[]): any[] {
    return sessions ? sessions?.filter((e) => e.sessionType === 'Survey') : [];
  }

  refreshFilters() {
    this.first = 1;
    this.status = undefined;
    this.oufilter = undefined;
    this.DateRange = undefined;
    this.getTrainingRequests();
  }

  //   Monthly filter
  filterByMonth() {
    if (this.selectedDate) {
      // this.filterRequestData = this.trainingRequestData.filter((record:any) => record.type?.name == 'New Branch');
      this.countStatusOccurrences();
      this.totalTraining = this.filterRequestData?.length;
    }
  }

  //get all training requests
  getTrainingRequests = async ($event?: any) => {
    if($event) {this.oufilter = $event.node;}
    try {
      this.statusCounts = {};

      let query: any = { status: this.status };

      query.type = this.trainingTypes.find(
        (item: any) => item.name == 'New Branch'
      )._id;

      if (this.DateRange && this.DateRange.length === 2) {
        query.createdAt = {
          $gte: this.orgUnits.getTimeForRequest(this.DateRange[0]),
          $lt: this.orgUnits.getTimeForRequest(this.DateRange[1]),
        };
      }

      if (this.oufilter) {
        query.ou = this.oufilter._id;
      }

      if (this.status == undefined) {
        delete query.status;
      }

      if (this.status == 'DEACTIVATED') {
        delete query.status;
        query.active = false;
      }

      this.spinner = true;

      this.trainingRequestData = [];

      if (this.managerPage) {
        query.ou = this.managerOu;
        query.active = true;
      }

      let master_trainer = localStorage.getItem('master_trainer');

      if (!!master_trainer && master_trainer == 'true')
        query.master_trainer = localStorage.getItem('uid');

      let UserRole = '';
      const externalUserString = localStorage.getItem('externalUser');

      if (externalUserString) {
        const externalUser = JSON.parse(externalUserString);
        if (externalUser && externalUser.role) {
          UserRole = externalUser.role;
        }
      }

      if (UserRole == 'trainer') query.trainer = localStorage.getItem('uid');

      if (this.hasPermission('NEW_BRANCH_TRAINING', 'r')) {
        delete query?.master_trainer;
        delete query.trainer;
      }

      let res = await this.dataService.postData(
        `training-program/get-merged-training-program-courses?offset=${this.rows}&page=${this.page}`,
        query
      );

      // let res = await this.dataService.postData(`training-req/get-aggregated-v2?offset=${this.rows}&page=${this.page}`, query);
      // let res = await this.dataService.postData(`training-req/get-aggregated?offset=${this.rows}&page=${this.page}`, query);

      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }

      this.trainingRequestData = res?.data?.data;

      this.filterRequestData = this.trainingRequestData;
      this.totalTraining = res?.data?.totalCount;
      this.spinner = false;
    } catch (error) {
      console.log(error);
    }
  };

  materTrainerPermission(materID: string) {
    return localStorage.getItem('uid') == materID;
  }

  //Function to get common fields of the selected data
  filterData(data: any, key: any, value: any) {
    let results: any = [];

    //Base Recursive Function
    function recursiveFilter(obj: any, parentObj = null) {
      if (Array.isArray(obj)) {
        obj.forEach((item) => recursiveFilter(item, parentObj));
      } else if (typeof obj === 'object') {
        if (obj != null && obj.hasOwnProperty(key) && obj[key] === value) {
          if (parentObj) {
            results.push(parentObj);
          }
          results.push(obj);
        }
        if (obj != null && obj != undefined)
          Object.values(obj).forEach((value) => recursiveFilter(value, obj));
      }
    }

    recursiveFilter(data);
    return results;
  }

  private updateTypeCounts(): void {
    if (this.typeFilter || this.oufilter || this.filteredData) {
      let activeCount = this.filteredData.filter(
        (e: any) => e.active === true
      ).length;
      let inactiveCount = this.filteredData.length - activeCount;
      this.stats = [
        {
          name: this.translate('active'),
          number: activeCount,
          icon: 'pi pi-check-circle',
        },
        {
          name: this.translate('Inactive'),
          number: inactiveCount,
          icon: 'pi pi-times-circle',
        },
      ];
    }
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  clearPublishDetails() {
    this.unregisteredUsers = [];
    this.branchUser = undefined;
    this.requestHolder = undefined;
  }

  findById(nodes: any[], id: string): any {
    let result;
    for (let node of nodes) {
      if (node != undefined && node != null) {
        if (node.id == id) {
          return node;
        }
        if (node.children) {
          result = this.findById(node.children, id);
          if (result) {
            return result;
          }
        }
      }
    }
    return result;
  }

  publish(request: any) {
    this.branchId = this.findById(this.selectedTreeData, request?.ou?.id);
    // this.branchId = { _id : request?.ou?._id}
    this.requestHolder = request;
    this.getAllBranchUsers();
    this.publishModal = true;
  }

  async submitPublish() {
    if (!this.branchId) return;
    this.branchId;
    let data = {
      _id: this.requestHolder._id,
      attendees: this.branchUser.map((e: any) => e._id),
      assignAll: true,
    };
    await this.assAttendees(data);
    let changeSatusData = {
      _id: this.requestHolder._id,
      status: 'PUBLISHED',
      unregisteredUsers: this.unregisteredUsers,
      ou: this.branchId?._id,
    };
    let res = await this.dataService.postData(
      'training-req/',
      changeSatusData,
      'PUT',
      false
    );
    this.publishModal = false;
    this.clearPublishDetails();
  }

  async getAllBranchUsers() {
    let res = await this.dataService.postData('user/training-users/', {
      ous: [this.requestHolder?.ou?._id],
      training: this.requestHolder._id,
    });
    this.branchUser = res.data;
  }

  deleteRequest(id: string) {
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteRequestAPI(id),
    });
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  async deleteRequestAPI(id: string) {
    try {
      let res = await this.dataService.deleteData('course/' + id);
      if (!res.error) {
        this.getTrainingRequests();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async activateDeactivate(id: string, status: boolean) {
    try {
      const data = {
        _id: id,
        active: status,
      };
      let res = await this.dataService.postData(
        'training-req/',
        data,
        'PUT',
        false
      );
      if (!res.error) {
        this.refreshFilters();
        this.getTrainingRequests();
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async deactivateInit() {
    try {
      if (
        this.rejectData.reason == undefined &&
        this.rejectData.status != 'APPROVED' &&
        this.rejectData.status != 'PUBLISHED' &&
        this.rejectData.status != 'TRAINING_CREATED'
      ) {
        this.reasonError = this.translate('Reason Required');
        return;
      }
      this.reasonError = undefined;
      let res = await this.dataService.postData(
        'training-req/',
        this.rejectData,
        'PUT',
        false
      );
      if (!res.error) {
        this.rejectReason = false;
        this.rejectData = {
          _id: null,
          reason: null,
          status: '',
        };

        this.refreshFilters();
        this.getTrainingRequests();
      } else {
        this.reasonError = res.msg;
      }
    } catch (error) {
      console.log(error);
    }
  }

  countStatusOccurrences() {
    this.filterRequestData.forEach((item: any) => {
      const status = item.status;
      if (this.statusCounts[status]) {
        this.statusCounts[status]++;
      } else {
        this.statusCounts[status] = 1;
      }
    });
  }

  async openCourse(req: any, view?: boolean) {
    try {
      let parems = {
        _id: req.trainingId._id,
        // flag : view ? 'VIEW' : 'EDIT',
        from: this.managerPage ? 'Manager' : 'SBC',
      };

      if (this.materTrainerPermission(req?.master_trainer)) {
        parems.from = 'SBC';
      }

      if (view) {
        parems.from = 'User';
      }

      this.navigateToTrainingPage(parems);

      // this.createCourseModal = false;
      // this.openCourseModal = true;
      // view ? req.view = true : req.view = false;
      // this.permissions = req;
      // let res = await this.dataService.getData('course/'+req._id);
      // if(res.error){
      //   return
      // }
      // this.trainingDetails = res.data[0]
      // console.log("==>COurse get",res);
    } catch (error) {
      console.log(error);
    }
  }

  navigateToTrainingPage(params: any) {
    const trainingId = params._id;
    this.router.navigate(['/training/training-page', trainingId], {
      queryParams: params,
    });
  }

  async getTreeData() {
    let data: any = await await this.orgUnits.getOrgUnits();
    this.selectedTreeData = [];

    //get weekly type
    let selectedid: any = this.trainingTypes.find(
      (e: any) => e.name == 'New Branch'
    ).allowed_ou;

    if (selectedid.label != 'الجهات المشاركة') {
      this.selectedTreeData.push(this.findNodeByName(data, selectedid._id));
      // Create a deep copy of the selected data using lodash.clonedeep
      this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);
      console.log('the selected tree 109', this.selectedTreeData);

      const uniqueTags = new Set();

      this.types.forEach((type: any) => {
        if (type && type.tag) {
          uniqueTags.add(type.tag);
        }
      });

      let uniqueTagsArray: MenuItem[] = [];

      uniqueTags.forEach((item: any) => {
        if (item != 'Ministries/Entities')
          uniqueTagsArray.push({ label: item });
      });

      this.selectedTreeTags = uniqueTagsArray;

      this.selectedTreeTags_current = this.selectedTreeTags[0];

      this.changeSelectedTag(this.selectedTreeTags_current);
    }
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log('change tag event', event);
    this.selectedTreeTags_current = {
      label: 'Branches',
    };
    if (this.selectedTreeTags_current.label) {
      await this.filterTreeByTag('Branches');
    } else {
      this.selectedTreeData = null;
    }
  }

  openResults(session: any) {
    let url;
    if (session?.type == 'SURVEY') {
      url = `/sa/survey/attempt/${session?.typeId}`;
    } else if (session?.type == 'ASSESSMENT') {
      url = `/assessment/results/${session?.typeId}?trainingView=true`;
    }
    if (url) {
      window.open(
        window.location.protocol + '//' + window.location.host + url,
        '_blank'
      );
    }
  }

  selectedTreeData: any = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = [];
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: [],
        });
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

  onPageChange(event: PageEvent) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1;
    this.getTrainingRequests();
  }

  // Add Users
  usersInCourse: any = [];
  course: any;
  addTrainer: boolean = false;

  addAttendees(courseData: any) {
    this.usersInCourse = [...courseData.trainingId.attendees];
    this.course = courseData;
    this.addTrainer = true;
  }

  async assNewTrainers(users: any) {
    if (users.emit == false || users.emit == true) {
      this.addTrainer = false;
    }

    let data = {
      _id: this.course._id,
      attendees: users.users.map((e: any) => e._id),
      assignAll: true,
    };

    await this.assAttendees(data);
  }

  async assAttendees(data: any) {
    try {
      let res = await this.dataService.postData(
        'course/assign-attendees',
        data,
        'PUT',
        false
      );
      if (!res.error) {
        this.getTrainingRequests();
        return;
      } else {
        return;
      }
    } catch (error) {
      console.log(error);
    }
  }

  librarySubmit(event: any) {
    this.openAddKLModal = false;
  }

  // Training Program

  updateHolder: any = undefined;
  selectedProgram: any;

  closeProgramAddFrom(event: any) {
    if (event) {
      this.getTrainingRequests();
    }
    this.addTrainingProgram = false;
    this.updateHolder = undefined;
  }

  updateTrainingProgram(event: any) {
    this.updateHolder = event;
    this.addTrainingProgram = true;
  }

  getNamesString(data: any): string {
    return data ? data.map((item: any) => item.name).join(', ') : '-';
  }

  //Approve log
  confirmApprove(logData: any) {
    let log: any = {
      _id: logData._id,
      status: 'PUBLISHED',
      courses: logData?.courses.map((e: any) => e.trainingId?._id),
    };
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.ApproveLog(log),
    });
  }

  //API Call Approve
  async ApproveLog(logData: any) {
    try {
      let res = await this.dataService.postData(
        'training-program/',
        logData,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('error'),
            detail: res.msg,
          },
        ];
        return;
      }
      this.messages = [
        {
          severity: 'success',
          summary: this.translate('success'),
          detail: res.msg,
        },
      ];

      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }

  handleProgram(req: any) {
    if (!!this.selectedProgram && this.selectedProgram._id == req._id)
      this.selectedProgram = undefined;
    else this.selectedProgram = req;
  }


    //Approve log
    confirmProgramDelete(logData: any) {
      let log: any = {
        _id: logData._id,
      };
      this.confirm({
        message: this.translate('Are you sure you want to do this?'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: () => this.deleteProgram(log),
      });
    }

   async deleteProgram(data:any){
      try {
        let res = await this.dataService.deleteData('training-program/' + data._id);
        if (!res?.error) {
          this.getTrainingRequests();
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
        }
        this.messages = [
          { severity: 'error', summary: this.translate('error') },
        ];

      } catch (error) {
        console.log(error);
      }
    }


}

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}
